/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Import_Csv_Validation_NameInputs */



/**
* | output |
* | --- |
* | "Enter a name for the new table." |
*
* @param {Datasets_Import_Csv_Validation_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_validation_name = /** @type {((inputs?: Datasets_Import_Csv_Validation_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_Validation_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie einen Namen für die neue Tabelle ein.")
	return /** @type {LocalizedString} */ ("Enter a name for the new table.")
});